import script from "./addAdvertiser.vue?vue&type=script&setup=true&lang=js"
export * from "./addAdvertiser.vue?vue&type=script&setup=true&lang=js"

import "./addAdvertiser.vue?vue&type=style&index=0&id=23a16751&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a16751"]])

export default __exports__